import React, { useState, useEffect, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalBody } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { ResponseSuccessModal, ResponseFailModal } from '../../modal/Response';
import Spin from '../../Spin';
import * as api from '../../../api';

const StaffUpdate = ({
  isOpen,
  toggle,
  reload,
  staffId,
}) => {
  const { t } = useTranslation();
  const [ isLoading, setIsLoading ] = useState(false);
  const [ isOpenStaffUpdateSuccessModal, setIsOpenStaffUpdateSuccessModal ] = useState(false);
  const [ isOpenStaffUpdateFailModal, setIsOpenStaffUpdateFailModal ] = useState(false);
  const [ messageStaffUpdateFail, setMessageStaffUpdateFail ] = useState('');
  const [ staffUpdateItem, setStaffUpdateItem ] = useState({
    name: '',
    role: '',
  });
  const roleItems = [
    { key: t('data.staff_role.master'), value: 'master' },
    { key: t('data.staff_role.manager'), value: 'manager' },
    { key: t('data.staff_role.housekeeping'), value: 'housekeeping' },
    { key: t('data.staff_role.manager_mobilekey'), value: 'manager_mobilekey' },
    { key: t('data.staff_role.doorlock_setting'), value: 'doorlock_setting' },
  ];

  const updateStaff = async () => {
    try {
      setIsLoading(true);
      await api.updateStaff({staffId, ...staffUpdateItem});
      toggle();
      setIsOpenStaffUpdateSuccessModal(true);
      setTimeout(() => {
        setIsOpenStaffUpdateSuccessModal(false);
        reload();
      }, 1500);
    } catch (error) {
      if (!error.response) setMessageStaffUpdateFail(error.message);
      else setMessageStaffUpdateFail(`${error.response.data.code}, ${error.response.data.message}`);
      setIsOpenStaffUpdateFailModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const selectStaff = async () => {
      const res = await api.selectStaff({staffId});
      setStaffUpdateItem({
        name: res.data.name,
        role: res.data.role,
      });
    };
    if (staffId) selectStaff();
  }, [staffId, isOpen]);

  return (
    <Fragment>
      <Modal
        show={isOpen}
        onHide={() => toggle()}
        centered
        backdrop='static'
        size='md'
      >
        <Spin isSpin={isLoading} isModal={true}/>
        <ModalBody className='text-center m-3' style={{margin:0, padding:0, backgroundColor:'#282C34'}}>
          <div className='form-card'>
            <div className='form-card-title'>
              <h4>{t('content_title.staff_edit')}</h4>
            </div>
            <div className='inline-flex'>
              <div className='w-50'>
                <div className='card-text'>
                  <p>
                    <b>{t('data_column.staff_name')}</b>
                    <span className='required'>*</span>
                  </p>
                  <input
                    className='card-text-input'
                    placeholder={t('placeholder.staff_name')}
                    value={staffUpdateItem.name}
                    onChange={e => setStaffUpdateItem({...staffUpdateItem, name:e.target.value})}
                  />
                </div>
                <div className='card-text'>
                  <p>
                    <b>{t('data_column.role')}</b>
                    <span className='required'>*</span>
                  </p>
                  <select
                    className='card-text-select'
                    value={staffUpdateItem.role}
                    onChange={e => setStaffUpdateItem({...staffUpdateItem, role:e.target.value})}
                  >
                    <option value='' hidden>{t('placeholder.role')}</option>
                    {roleItems.map((role, index) => (
                      <option key={index} value={role.value}>{role.key}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className='card-foot'>
              <div className='form-item-cancel'>
                <button className='btn-item-cancel' onClick={() => toggle()}>
                  <FontAwesomeIcon icon={faTimesCircle} style={{paddingRight:'3px'}}/><span>{t('button.cancel')}</span>
                </button>
              </div>
              <div className='form-item-add center'>
                <button className='btn-item-add' onClick={updateStaff}>
                  <FontAwesomeIcon icon={faSave} style={{paddingRight:'2px'}}/><span>{t('button.save')}</span>
                </button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <ResponseSuccessModal
        isOpen={isOpenStaffUpdateSuccessModal}
        toggle={() => setIsOpenStaffUpdateSuccessModal(!isOpenStaffUpdateSuccessModal)}
        message={t('success_message.edit_staff')}
      />
      <ResponseFailModal
        isOpen={isOpenStaffUpdateFailModal}
        toggle={() => setIsOpenStaffUpdateFailModal(!isOpenStaffUpdateFailModal)}
        message={messageStaffUpdateFail || t('error_message.edit_staff')}
      />
    </Fragment>
  );
};

export default StaffUpdate;